export const DICTIONARY_DATA = [
  {
    inspectorName: '**ABCD Misc',
    fieldName: 'ABCDMisc',
    definition: 'A code used to indicate the Forest Service job accounting code for the incident. This is specific to the Forest Service. Usually displayed as 2 char prefix on FireCode.',
    dataType: 'varchar(4)',
    uiGrouping: 'Incident'
  },
  {
    inspectorName: 'Activity / Group',
    fieldName: 'FireCauseActivityGroup',
    definition: 'For Fire Cause, further refines information for prevention programs for targeted messaging. Examples: Private/Residential; Farming/Ranching; Logging',
    dataType: 'domain',
    uiGrouping: 'Fire Cause/Fire Summary'
  },
  {
    inspectorName: 'Age Category',
    fieldName: 'NA',
    definition: 'For Fire Cause, when Human, discriminates between children (0-12), adolescents (13-17), and adults (18+)',
    dataType: 'domain',
    uiGrouping: 'Fire Cause/Fire Summary'
  },
  {
    inspectorName: 'Calculated Size (ac)',
    fieldName: 'CalculatedAcres',
    definition: 'A measure of acres calculated (i.e., infrared) from a geospatial perimeter of a fire. More specifically, the number of acres within the current perimeter of a specific, individual incident, including unburned and unburnable islands. The minimum size must be 0.1.',
    dataType: 'double',
    uiGrouping: 'Size'
  },
  {
    inspectorName: 'Cause Comments',
    fieldName: 'FireCauseComments',
    definition: 'Add comments related to Fire Cause',
    dataType: 'Text box',
    uiGrouping: 'Fire Cause/Fire Summary'
  },
  {
    inspectorName: 'Cause Investigated?',
    fieldName: 'IsFireCauseInvestigated',
    definition: 'Indicates if an investigation is underway or was completed to determine the cause of a fire.',
    dataType: 'boolean',
    uiGrouping: 'Fire Cause/Fire Summary'
  },
  {
    inspectorName: 'Certified Date',
    fieldName: 'FinalFireReportApprovedDate',
    definition: 'The date that the final fire report was approved for the incident.',
    dataType: 'datetime',
    uiGrouping: 'Chronology'
  },
  {
    inspectorName: 'Containment/Containment Date Time',
    fieldName: 'ContainmentDateTime',
    definition: 'The date and time a wildfire was declared contained.',
    dataType: 'datetime',
    uiGrouping: 'Chronology/Certification'
  },
  {
    inspectorName: 'Control',
    fieldName: 'ControlDateTime',
    definition: 'The date and time a wildfire was declared under control.',
    dataType: 'datetime',
    uiGrouping: 'Chronology'
  },
  {
    inspectorName: '*(S)County',
    fieldName: 'POOCounty',
    definition: 'The County Name identifying the county or equivalent entity at point of origin designated at the time of collection.',
    dataType: 'varchar(100)',
    uiGrouping: 'Point of Origin/Fire Summary'
  },
  {
    inspectorName: 'Created by System',
    fieldName: 'CreatedBySystem',
    definition: 'ArcGIS Server Username of system that created the IRWIN Incident record. Assigned by IRWIN',
    dataType: 'Varchar(255)',
    uiGrouping: 'Miscellaneous'
  },
  {
    inspectorName: 'Created On Date Time',
    fieldName: 'CreatedOndatetime',
    definition: 'Date/time that the IRWIN Incident record was created.',
    dataType: 'datetime',
    uiGrouping: 'Chronology'
  },
  {
    inspectorName: '*(S)Incident Size (ac)',
    fieldName: 'IncidentSize',
    definition: 'A measure of acres reported for a fire. More specifically, the number of acres within the current perimeter of a specific, individual incident, including unburned and unburnable islands. The minimum size must be 0.1.',
    dataType: 'double',
    uiGrouping: 'Size'
  },
  {
    inspectorName: 'Derived Dispatch Center ID',
    fieldName: 'POODispatchCenterID',
    definition: 'A unique identifier for the dispatch center that intersects with the incident point of origin.',
    dataType: 'varchar(6)',
    uiGrouping: 'Point of Origin'
  },
  {
    inspectorName: '*(S)Discovery',
    fieldName: 'FireDiscoverydatetime',
    definition: 'The date and time a fire was reported as discovered or confirmed to exist. May also be the start date for reporting purposes.',
    dataType: 'datetime',
    uiGrouping: 'Chronology/Fire Summary/Certification'
  },
  {
    inspectorName: 'Dispatch Center ID',
    fieldName: 'DispatchCenterID',
    definition: 'A unique identifier for a dispatch center currently responsible for supporting and managing the incident. NOTE: if the incident was created by a NON CAD application, then this DispatchCenterID is derived from a geospatial lookup based on POO Latitude and Longitude and may NOT reflect the center currently responsible if it has not been updated by a CAD.',
    dataType: 'varchar(6)',
    uiGrouping: 'NA'
  },
  {
    inspectorName: 'Estimated Containment Date',
    fieldName: 'EstimatedContainmentDate',
    definition: 'The estimated date a wildfire will be contained.',
    dataType: 'datetime',
    uiGrouping: 'Chronology'
  },
  {
    inspectorName: 'Final Fire Report Approved By',
    fieldName: 'FinalFireReportApprovedBy',
    definition: 'The name of the person that approved the final fire report for the incident.',
    dataType: 'varchar(100)',
    uiGrouping: 'Approval'
  },
  {
    inspectorName: 'Final Fire Report Approved By Title',
    fieldName: 'FinalFireReportApprovedByTitle',
    definition: 'The title of the person that approved the final fire report for the incident.',
    dataType: 'varchar(100)',
    uiGrouping: 'Approval'
  },
  {
    inspectorName: 'Final Fire Report Approved By Unit',
    fieldName: 'FinalFireReportApprovedByUnit',
    definition: 'NWCG Unit ID associated with the individual who approved the final report for the incident.',
    dataType: 'varchar(6)',
    uiGrouping: 'Approval'
  },
  {
    inspectorName: 'Final Strategy Attained',
    fieldName: 'FinalStrategyAttainedDateTime',
    definition: 'The date/time the final fire strategy was accomplished on the incident.',
    dataType: 'datetime',
    uiGrouping: 'Chronology'
  },
  {
    inspectorName: '*(S)Fire Cause',
    fieldName: 'FireCause',
    definition: 'Broad classification of the reason the fire occurred identified as human, natural or unknown.',
    dataType: 'varchar(15)',
    uiGrouping: 'Fire Cause/Fire Summary'
  },
  {
    inspectorName: '*(S)Fire Cause General',
    fieldName: 'FireCauseGeneral',
    definition: 'Agency or circumstance which started a fire or set the stage for its occurrence; source of a fire\'s ignition. For statistical purposes, fire causes are further broken into specific causes.',
    dataType: 'varchar(100)',
    uiGrouping: 'Fire Cause/Fire Summary'
  },
  {
    inspectorName: 'Fire Cause Specific',
    fieldName: 'FireCauseSpecific',
    definition: 'A further categorization of each General Fire Cause to indicate more specifically the agency or circumstance which started a fire or set the stage for its occurrence; source of a fire\'s ignition.',
    dataType: 'varchar(200)',
    uiGrouping: 'Fire Cause/Fire Summary'
  },
  {
    inspectorName: '*Fire Declared Out',
    fieldName: 'FireOutdatetime',
    definition: 'The date and time when a fire is declared out.',
    dataType: 'datetime',
    uiGrouping: 'Chronology/Fire Summary'
  },
  {
    inspectorName: 'Fire Detection Method',
    fieldName: 'NA',
    definition: 'Domain list indicating how or who detected the fire',
    dataType: 'domain',
    uiGrouping: 'Point of Origin'
  },
  {
    inspectorName: '*Firecode',
    fieldName: 'FireCode',
    definition: 'A code used within the interagency wildland fire community to track and compile cost information for emergency fire suppression expenditures for the incident.',
    dataType: 'varchar(4)',
    uiGrouping: 'Incident/Fire Summary (Fire Code)/Header'
  },
  {
    inspectorName: 'FORID',
    fieldName: 'NA',
    definition: 'A unique identifier for a fire occurrence report.',
    dataType: 'varchar(50)',
    uiGrouping: 'Incident/Fire Summary/Header'
  }
]; 